import React from 'react';
import { Globe } from 'lucide-react';
import '../styles/LanguageToggle.css';

const LanguageToggle = ({ language, toggleLanguage }) => {
  return (
    <button
      onClick={toggleLanguage}
      className={`language-toggle-button ${language.toLowerCase()}`}
    >
      <div className="language-toggle-content">
        <Globe size={16} className="language-toggle-icon" />
        <div className="language-toggle-text">{language}</div>
      </div>
    </button>
  );
};

export default LanguageToggle;